export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export type monthType = typeof months[number];

export const enum ViewTypes {
  Month = 'Month',
  Year = 'Year',
}

export const enum HolidaysType {
  Shortened = 'Shortened day',
  Free = 'Free day'
}
